import { render, staticRenderFns } from "./SideMenuTabs.vue?vue&type=template&id=7afd0a4f"
import script from "./SideMenuTabs.vue?vue&type=script&lang=js"
export * from "./SideMenuTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports